import axios from 'axios'
import config from '@/api/config'
import md5 from 'md5'
import { message } from '@/utils/messageOnce'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import router from '@/router'
const instance = axios.create({
    baseURL: config.baseURL,
    timeout: config.timeout,
})



const initFingerprint = () => {
    return new Promise((resolve) => {
        FingerprintJS.load().then((fin) => {
            fin.get().then((res) => {
                const v = res.visitorId
                const a = (res.components.audio.value + '-' + res.components.audio.duration).replace('.', '-')
                const s = res.components.screenResolution.value + '-' + res.components.screenResolution.duration
                const l = res.components.languages.value + '-' + res.components.languages.duration
                const d = res.components.deviceMemory.value + '-' + res.components.deviceMemory.duration
                localStorage.setItem('v', v)
                localStorage.setItem('a', a)
                localStorage.setItem('s', s)
                localStorage.setItem('l', l)
                localStorage.setItem('d', d)
                resolve()
            })
        })
    })
}

const generatePin = async () => {
    // 优先从 localStorage 获取
    const v = localStorage.getItem('v')
    const a = localStorage.getItem('a')
    const s = localStorage.getItem('s')
    const l = localStorage.getItem('l')
    const d = localStorage.getItem('d')

    // 若任一字段缺失则重新生成
    if (!v || !a || !s || !l || !d) {
        await initFingerprint()
    }

    // 重新获取最新值
    const currentV = localStorage.getItem('v')
    const currentA = localStorage.getItem('a')
    const currentS = localStorage.getItem('s')
    const currentL = localStorage.getItem('l')
    const currentD = localStorage.getItem('d')

    const k = 'zlrcw'
    const t = new Date().getTime()
    const n = md5(currentV + currentA + currentS + currentL + currentD + k + t)
    return `${currentV}.${currentA}.${currentS}.${currentL}.${currentD}.${t}.${n}`
}

instance.interceptors.request.use(
    async (config) => {
        const token = localStorage.getItem('token')
        config.headers['x-device-visitor'] = await generatePin()
        config.headers['device-id'] = localStorage.getItem('device-id')
        if (token) {
            config.headers.token = token
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

instance.interceptors.response.use( 
    (response) => {
        
        const dataAxios = response.data
        if (dataAxios.code === 776 || dataAxios.code === 777) {
            message.error(dataAxios.message)
            localStorage.clear()
            sessionStorage.removeItem('openFreeMenu')
            router.push({
                name: 'newIndex'
            })
            // setTimeout(() => {
            //     window.location.href =
            //         process.env.NODE_ENV === 'development' ? 'https://dev-web.zilieai.com/#/login' : 'https://zilie.com/#/login'
            // }, 1500)
            return new Promise(() => {})
        } else if (dataAxios.code === 666) {
            message.error('您的账号已在其他地方登录，请重新登录后使用')
            localStorage.clear()
            sessionStorage.removeItem('openFreeMenu')
            router.push({
                name: 'newIndex'
            })
            // setTimeout(() => {
            //     window.location.href =
            //         process.env.NODE_ENV === 'development' ? 'https://dev-web.zilieai.com/#/login' : 'https://zilie.com/#/login'
            // }, 1500)
            return new Promise(() => {})
        }
        if (response.config.url.includes('profile') && dataAxios.data) {
            dataAxios.data.network = {
                requsetTime: Date.now()
            }
        }
        return dataAxios
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default instance
